.container {
  border: 2px solid var(--dds-color-border-danger);
}
